import React from 'react';
import { useUser, UserContext } from '../GoogleAuth';
import Menu from './Menu';
import AppContent from './Content';
import { Alert } from 'react-bootstrap';

export default function Layout(): JSX.Element {
    const user = useUser();

    if (user === null) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-grow" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <UserContext.Provider value={user}>
                <Menu user={user} />
                <div className="body AppContent d-flex flex-column">
                    {/*
                    <Alert variant={'warning'}>
                        <b>September 4th - 7th, 2025</b> services using SAP will be unavailable. Spare Parts and other functionality will NOT be available
                    </Alert>
                    */}

                    <AppContent user={user} />
                </div>
            </UserContext.Provider>
        </>
    );
}
